<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form ref="ff" size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.keyWord" clearable placeholder="询价编码/标题/客户" />
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>

    <!--表格-->
    <el-table :data="datalist.Items" height="100%">
      <el-table-column type="expand">
        <el-descriptions :column="2" slot-scope="{ row }">
          <el-descriptions-item label="询价目录">{{ row.Columns }}</el-descriptions-item>
          <el-descriptions-item label="报价时间">{{ row.BeginDate }} 至 {{ row.ExpiryDate }}</el-descriptions-item>
          <el-descriptions-item label="商务要求" v-if="row.Demands">
            <el-popover trigger="click" placement="right" popper-class="popcss">
              <el-link slot="reference" type="primary" :underline="false">查看</el-link>
              {{ row.Demands }}
            </el-popover>
          </el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ row.Linkman }} - {{ row.Linktel }}</el-descriptions-item>
          <el-descriptions-item label="已报价">{{ row.Tendered }} 家</el-descriptions-item>
          <el-descriptions-item label="送货地址">{{ row.Address }}</el-descriptions-item>
        </el-descriptions>
      </el-table-column>
      <el-table-column prop="Mode.Text" label="询价类别" width="80" />
      <el-table-column prop="Code" label="询价单号" width="160">
        <template slot-scope="{ row }">
          <el-link v-if="row.Mode.Code == 'zxxj'" type="primary" :href="'https://zxxj.zcygov.cn/bidding/detail?type=BIDDING_INVITATION&requisitionId=' + row.Code" target="_blank">{{ row.Code }}</el-link>
          <el-link v-else-if="row.Mode.Code == 'fxjj'" type="primary" :href="'https://fxjj.zcygov.cn/bidding/detail?type=BIDDING_INVITATION&requisitionId=' + row.Code" target="_blank">{{ row.Code }}</el-link>
          <el-link v-else-if="row.Mode.Code == 'jbxx'" type="primary" :href="'https://inquiryhall.zcygov.cn/inquiryhall/detail?inquiryId=' + row.Code" target="_blank">{{ row.Code }}</el-link>
          <template v-else>{{ row.Code }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="Title" label="询价标题" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Customer" label="客户信息" min-width="200" show-overflow-tooltip />
      <el-table-column label="控制总价" min-width="100">
        <template slot-scope="{ row }">
          <p class="text-price text-danger">{{ row.BudgetPrice }}</p>
          <p class="describe" v-if="row.FinalPrice">成交价￥{{ row.FinalPrice }}</p>
        </template>
      </el-table-column>
      <el-table-column label="截止时间" min-width="100">
        <template slot-scope="{ row }">
          <span v-if="row.Surplus > 0 && row.Surplus < 24" style="color: #f56c6c">剩余{{ row.Surplus }}小时</span>
          <span v-else>{{ $utils.common.parseTime(row.ExpiryDate, '{m}/{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="80">
        <el-link v-action="'/api/ProjectManage/Inquiry/SetGrabbing'" slot-scope="{ row }" type="primary" @click="onGrabbing(row)">截单</el-link>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onPager" />
  </full-container>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      datalist: {},
      queryParams: {},
    }
  },
  created () {
    this.resetForm()
  },
  methods: {
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    resetForm () {
      this.queryParams = { index: 1, size: 20 }
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.project.inquiry.pendings(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //截单
    onGrabbing (row) {
      this.$confirm('确定领取该任务吗?', row.Title, {
        center: true
      }).then(() => {
        this.$apis.project.inquiry.grabbing({ id: row.Id }).then(() => {
          this.$message({ message: "领取成功！", type: "success" })
          this.resetForm()
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-descriptions__body) {
  .el-descriptions-row:hover {
    background-color: unset !important;
  }
  .el-descriptions-item {
    border: unset !important;
    padding: 5px 10px;
    &__label {
      min-width: 80px;
      color: #99a9bf;
    }
  }
}
.describe {
  span + span {
    margin-left: 10px;
  }
  .el-link {
    font-size: 10px;
    margin-left: 10px;
  }
}
</style>
